import { ControlType } from 'src/app/shared/forms/models/control-type.enum';

export class ActiveFilter {
  controlType?: ControlType;
  label?: string;
  propertyBinding?: string;
  propertyValue?: any;
  value?: any;
}
